module.exports = __webpack_public_path__ + "static/Millimetre-Regular_web-bc6b97bd7f8f73e70a72bf21f23ba591.eot";